<template>
	<div>
		<metainfo>
			<template v-slot:title="{ content }">
				{{ content ? `${content} | مجلة بحوث جامعة حلب` : `مجلة بحوث جامعة حلب` }}
			</template>
		</metainfo>

		<loader v-if="loadingLang"></loader>
		<template v-else>
			<navbar
				@change-lang="changeLanguage"
				@loading:active="loadingSeriesAndVolumes = true"
				@loading:disable="loadingSeriesAndVolumes = false" />
			<router-view id="main-content" :loadingSeriesAndVolumes="loadingSeriesAndVolumes" />
			<v-footer />
		</template>
	</div>
</template>

<script>
import Navbar from './components/Navbar.vue';
import Footer from './components/Footer.vue';
import { useMeta } from 'vue-meta';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../public/assets/font-awsome-all';
import Loader from './components/Loader.vue';

export default {
	mounted() {
		this.$store.dispatch('statistics/addVisit');
	},

	setup() {
		useMeta({
			title: '',
		});
	},

	data() {
		return {
			loadingLang: false,
			loadingSeriesAndVolumes: false,
		};
	},

	methods: {
		changeLanguage(lang) {
			this.loadingLang = true;
			this.$i18n.locale = lang;
			window.axios.defaults.headers.common['Accept-Language'] = this.$i18n.locale;

			setTimeout(() => {
				this.loadingLang = false;
			}, 1000);
		},
	},

	components: {
		Navbar,
		'v-footer': Footer,
		Loader,
	},
};
</script>
<style>
@import '~bootstrap/dist/css/bootstrap.min.css';

:root {
	--green-color: #34854b;
	--yellow-color: #f5c730;
	--yellow-color-2: #aaad3c;
	--grey-color: #393939;
	--black-color: #141414;
	--borders-color: #e9e9e9;

	/** for the two thumbe slider */
	--slider-connect-bg: var(--green-color);
	--slider-tooltip-bg: var(--green-color);
	--slider-handle-ring-color: var(--green-color);
}

@font-face {
	font-family: change;
	src: url('../public/assets/Fonts/Changa/static/Changa-Regular.ttf');
}
@font-face {
	font-family: changeBold;
	src: url('../public/assets/Fonts/Changa/static/Changa-Bold.ttf');
}
@font-face {
	font-family: changeBoldSemi;
	src: url('../public/assets/Fonts/Changa/static/Changa-SemiBold.ttf');
}
@font-face {
	font-family: changeMedium;
	src: url('../public/assets/Fonts/Changa/static/Changa-Medium.ttf');
}

* {
	padding: 0;
	margin: 0;
	box-sizing: border-box;
	font-family: change;
	color: var(--grey-color);
}
.ar {
	direction: rtl;
	text-align: right;
}
.en {
	direction: ltr;
	text-align: left;
}
a {
	color: inherit;
	text-decoration: none;
	font-family: inherit;
}
a:hover {
	transition: color 0.15s;
	color: var(--green-color);
}
.container {
	max-width: none;
	padding: 0;
	margin: 0;
}
#app .vel-icon {
	fill: #eee;
}
#main-content {
	min-height: 60vh;
}

input,
select {
	transition: border-bottom 0.3s;
}

input[required]:invalid.not-valid,
select[required]:invalid.not-valid {
	border-bottom: 2px solid var(--yellow-color);
	animation: not-valid-shake 0.5s ease;
}
button[type='submit'] {
	display: flex;
}

button[type='submit'].disabled {
	pointer-events: none;
	background-image: linear-gradient(to right, rgb(139, 139, 139), rgb(100, 100, 100));
}

@keyframes not-valid-shake {
	0% {
		transform: translateX(0);
	}
	20% {
		transform: translateX(-5px);
	}
	40% {
		transform: translateX(5px);
	}
	60% {
		transform: translateX(-5px);
	}
	80% {
		transform: translateX(5px);
	}
	100% {
		transform: translateX(0);
	}
}

select[disabled] {
	background-color: rgb(245, 245, 245);
}

.spinner-grow {
	/* width: 1.4rem; */
	/* height: 1.4rem; */
}
</style>
